import { render, staticRenderFns } from "./SearchPicker.vue?vue&type=template&id=4b0bbd15"
import script from "./SearchPicker.vue?vue&type=script&lang=js"
export * from "./SearchPicker.vue?vue&type=script&lang=js"
import style0 from "./SearchPicker.vue?vue&type=style&index=0&id=4b0bbd15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports